/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';

import { TimePicker } from 'components/rfs-ui';
import { isFunction } from 'utils/lodash';
import { PTInput } from '../propTypes';

const TimePickerComponent = ({ input, meta, onChange, ...props }) => {
  const handleChange = useCallback(
    (value) => {
      input.onChange(value);
      if (isFunction(onChange)) {
        onChange(value);
      }
    },
    [onChange, input],
  );

  return <TimePicker {...props} onChange={handleChange} value={input.value || undefined} />;
};

TimePickerComponent.propTypes = {
  ...TimePicker.propTypes,
  ...PTInput,
};

export default TimePickerComponent;
